"use client";

import Modal from "@/components/core/Modal";
import { memo, ReactNode } from "react";
import GetToolModalHeader from "@/components/layouts/ToolModals/DetailToolModal/ToolModalHeader";
import ToolDetails from "@/components/layouts/ToolModals/DetailToolModal/ToolDetails";
import { ITool } from "@/actions/ai-configuration/tool/types";

interface DetailToolModalProps {
  toolData: ITool | null;
  isOpen: boolean;
  isLoading?: boolean;
  isError?: boolean;
  onOpenChange: (isOpen: boolean) => void;
}

const DetailToolModal = memo(
  ({
    isOpen,
    onOpenChange,
    toolData,
    isError,
    isLoading,
  }: DetailToolModalProps): ReactNode => {
    return (
      <Modal
        isOpen={isOpen}
        onOpenChange={(open) => {
          onOpenChange(open);
          if (!open) {
            document.body.classList.add("modal-unlocked");
          }
        }}
        dialogTitle="Detalhes da Mensagem"
        dialogDescription="Informações e observações da mensagem"
        className="flex flex-col w-full max-w-screen-tablet items-start justify-start gap-0"
        noDefaultCloseButton
      >
        <GetToolModalHeader backFn={() => onOpenChange(false)} />

        <div className="w-full overflow-auto max-h-[70vh]">
          {isLoading && (
            <div className="p-4 w-full text-center">Carregando...</div>
          )}

          {isError && (
            <div className="p-4 w-full text-center text-red-500">
              Ocorreu um erro ao buscar os dados.
            </div>
          )}

          {!isLoading && !isError && toolData && (
            <div className="p-4">
              <ToolDetails data={toolData} />
            </div>
          )}
        </div>
      </Modal>
    );
  },
);

DetailToolModal.displayName = "DetailToolModal";

export default DetailToolModal;
